import fetch from '../utils/fetch'


/******店铺推广**********/
export function createBgImg (params) {
  return fetch({
    url: '/spread/bg_img',
    method: 'post',
    data: params
  })
}


export function getBgImg (query) {
  return fetch({
    url: '/spread/bg_img',
    method: 'get',
    params: query
  })
}
export function getContentList (query) {
  return fetch({
    url: '/spread/content',
    method: 'get',
    params: query
  })
}
export function getRebateList (query) {
  return fetch({
    url: '/spread/rebate',
    method: 'get',
    params: query
  })
}
export function getDistributorLogsList (query) {
  return fetch({
    url: '/spread/distributor_logs',
    method: 'get',
    params: query
  })
}

export function exportData (query) {
    return fetch({
        url: '/spread/get/exportData',
        method: 'get',
        params: query
    })
}

/******敬之保险相关**********/



// WEBPACK FOOTER //
// ./src/api/spread.js